$(document).ready(function() {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
       // console.log(variant['available']);
if(variant['available'] == false){
  $('body').find('.newflex_box').attr('id','notavailable');
}else{
   $('body').find('.newflex_box').attr('id','available'); 
}
	  });

});

